import { LineItemsRowV2 } from 'shared/src/domain/io/io-types';

export type CopyType = 'standard' | 'net/gross' | 'mgmt-fee';

export function estimatedUnitsStandardFormula(
  unitPriceField: string,
  priceField: string,
  unitPriceTypeField: string
) {
  const unitPriceDivisor = `IF(${unitPriceTypeField} = "CPM", ${unitPriceField}/1000, ${unitPriceField})`;
  return `=IF(${unitPriceField}=0, 0, ${priceField}/${unitPriceDivisor})`;
}

export function estimatedUnitsMgmtFeeFormula(
  mediaBudgetField: string,
  unitCostField: string,
  unitPriceTypeField: string
) {
  const unitCostDivisor = `IF(${unitPriceTypeField} = "CPM", ${unitCostField}/1000, ${unitCostField})`;
  return `=IF(${unitCostField}=0, 0, ${mediaBudgetField}/${unitCostDivisor})`;
}

export function mediaBudgetZeroDollarFormula(
  estimatedUnitsField: string,
  unitCostField: string,
  unitPriceTypeField: string
) {
  const unitCostDivisor = `IF(${unitPriceTypeField} = "CPM", ${unitCostField}/1000, ${unitCostField})`;
  return `=IF(${unitCostField}=0, 0, ${estimatedUnitsField}*${unitCostDivisor})`;
}

export function getCopyTypeLabel(copyType: CopyType) {
  switch (copyType) {
    case 'standard':
      return 'Standard';
    case 'net/gross':
      return 'Net/Gross';
    case 'mgmt-fee':
      return 'Management Fee';
  }
}

export function isMgmtFeeItemV2(lineItem: LineItemsRowV2) {
  return lineItem.line_item_type === 'Management Fee';
}

export function isZeroDollarItemV2(lineItem: LineItemsRowV2) {
  return lineItem.line_item_type === 'Zero Dollar';
}

export function removeLineBreaks(value: string | null | undefined): string | null | undefined {
  if (value === null) return null;
  if (value === undefined) return undefined;
  return value.replace(/\r\n|\r|\n/g, ' ');
}
